export var MAP_TILER_APIKEY = "QlUt60mxyhOju7ZFq6cb";
//Old style: ac216796-6d5d-4f21-a7ce-d80a4b3a45e4
//New style: 43db46b1-02d3-4fe1-ae7b-cd02b1aa87e0
export var MAP_TILER_STYLE = "43db46b1-02d3-4fe1-ae7b-cd02b1aa87e0";
export var COLORS = {
  primary: "#2B5DFF",
  lightPrimary: "#d2e3f3"
};
export var MAP_TILER_VALUATION_IMAGE_SIZE = "1000x600";
export var MAP_TILER_VALUATION_IMAGE_SIZE_SMALL = "360x360";
export var MAP_TILER_VALUATION_ZOOM = 13;
export var MAP_TILER_VALUATION_CUSTOM_MOBILE_ZOOM = 14;
export var MAP_TILER_VALUATION_ZOOM_AGENCY_DETAILS = 16;
export var MAP_TILER_VALUATION_ZOOM_SAVED_ZONES = 11;
export var MAP_TILER_VALUATION_ZOOM_SAVED_SEARCHES = 10;
export var MAP_TILER_VALUATION_ZOOM_SAVED_SEARCHES_PROV = 7;